import React, {FC, useContext} from "react";
import {useTranslation} from "react-i18next";
import {Outlet, useNavigate} from "react-router-dom";
import Header from "Components/Layout/Header";
import {UserContext} from "../../Vendor/Context/UserContextProvider";


export const DashboardPage: FC = () => {
    const { t } = useTranslation()

    const { getInitialPage } = useContext(UserContext)
    const navigate = useNavigate()

    navigate(getInitialPage())

    return (
        <>
            <Header title={t('app.dashboard')} add={undefined}/>
            <Outlet />
        </>
    )
}
